/**
 * Global JS for Manage My Reservation
 * @author rubenvdb
 */


function call(function_name, post_data){
	var return_data = null;
	$.ajax({
		type: 'POST',
		async: false,
		global: false,
		url: '/ajax/' + function_name + '/',
		data: post_data,
		success: function(data){
			if(data['status'] == "OK"){
				return_data = data['data'];
			}
			else {
				throw data;
			}
		},
		dataType: 'json'
	});
	return return_data;
}
window.call = call;

function acall(function_name, post_data, success_function, error_function){
	$.ajax({
		type: 'POST',
		url: '/ajax/' + function_name + '/',
		data: post_data,
		global: false,
		success: function(data){
			if(data['status'] == "OK"){
				success_function(data['data']);
			}
			else {
				error_function(data);
			}
		},
		error: error_function,
		dataType: 'json'
	});
}
window.acall = acall;

function agetcall(function_name, get_data, success_function, error_function) {
  $.ajax({
    type: 'GET',
    url: '/ajax/' + function_name + '/',
    data: get_data,
    global: false,
    success: function (data) {
      if ((data !== null) && (typeof data['status'] !== 'undefined') && (data['status'] == "OK")) {
        if (typeof success_function == 'function') {
          success_function(data['data']);
        }
      }
      else {
        error_function(data);
      }
    },
    error: error_function,
    dataType: 'json'
  });
}
window.agetcall = agetcall;

function submitForm(form_sel, success_func, error_func)
{
	$(form_sel).find('.savebutton').button('loading');
	$.post($(form_sel).attr('action'), $(form_sel).serialize(), function(data) {
		$(form_sel).find('.savebutton').button('reset');

		if(data["status"] == "OK"){
			success_func(data['data']);
		}
		else {
			error_func(data['data']);
		}
	}, 'json');
}
window.submitForm = submitForm;


function showAlert(title, message, type, close, autoclose)
{
    var alertClass = 'alert';
    switch(type){

        case 'error':
        case 'danger':
            alertClass += ' alert-danger';
            break;
        case 'success':
            alertClass += ' alert-success';
            break;
        case 'warning':
        case 'message':
            alertClass += ' alert-warning';
            break;
        default:
            alertClass += ' alert-info';
            break;
    }

    var newAlert = jQuery("<div>", { "class": alertClass });
    var h = '';
    if(close == null || close == true){
        h += '<button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>';
    }
    h += '<strong>' + title + '</strong> ' + message;
    newAlert.html(h);
    $('#alert-area .container').append(newAlert);
    newAlert.alert();

    if(autoclose != null){
        setTimeout(function(){
            newAlert.alert('close');
        }, autoclose*1000);
    }

    return newAlert;
}
window.showAlert = showAlert;

function mouseIsOver(selector, x, y){
    var pos = selector.offset();
    var width = selector.outerWidth();
    var height = selector.outerHeight();

    if((x >= pos.left) && (x <= pos.left + width)){
        if((y >= pos.top) && (y <= pos.top + height)){
            return true;
        }
        else{
            return false;
        }
    }
    else{
        return false;
    }
}
window.mouseIsOver = mouseIsOver;

function refresh_notifications(){
    //get latest notifications
    try{
        var notifications = call('notifications/refresh');
        if(notifications.length > 0){
            $.each(notifications, function() {
                showAlert(this.title, this.message, this.type, true, null);
            });
        }
    }catch(e){
        console.log('failed to refresh notifications');
    }
}
window.refresh_notifications = refresh_notifications;

var isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};
window.isMobile = isMobile;


//Help link
$(function(){
    var resellerId = $('.navbar-brand').data('reseller-id');
    if(resellerId && resellerId.length > 0){
        $('.help-link').on('click', function(e){
            e.preventDefault();
            var helpUrl = "/help/" + resellerId;
            location.href = helpUrl;
        });
    }

    //Remove modals that get hidden from the dom
    $('body').on('hidden.bs.modal', '.modal', function () {
        $(this).remove();
    });
});



// WEBPACK FOOTER //
// ./common.js